export const config = {

  webWorker: typeof window === 'undefined',

  development: process.env.MODE == 'development',

  domain: 'successwizard.com',

  sentryDSN: 'https://c05fd6fd28b84729b75ff9e53dc6cf3e@o335160.ingest.sentry.io/4504759237083136',

  googleCalendar: {
    apiKey: 'AIzaSyDPIbj-iXE9vJlh0KRn543wRO9Fd8qZgU8',
    clientId: '217475191003-rripin1iumvi53ironvua8316h08lie5.apps.googleusercontent.com',
  },

  deviceId: new Date().getTime(),

  app: 'sw',
  appHost: process.env.MODE == 'development' ? 'localhost' : 'successwizard.com',
  appName: 'Success Wizard',
  appStoreURL: 'https://itunes.apple.com/app/id586970083',
  todayModule: 'My Day',
  clarityModule: 'starter',
  eveningRoutine: 'End My Day',
  googlePlayURL: 'https://play.google.com/store/apps/details?id=com.way4app.successwizard&hl=en',
  identityModule: 'clarity',
  morningRoutine: 'Start My Day',
  proPlan: 'Pro',
  sw: true,

  questions: {
    morning_thoughts_10: "What\'s important for me today?",
    morning_thoughts_20: "What are my intentions for today? What should I focus on?",
    reflections_1_10: "What were my 'high' and 'low' points – the best and worse experiences today?",
    reflections_1_20: "What made me motivated and energized today?",
    reflections_1_30: "What made me angry, worried or frustrated?",
    reflections_1_40: "What caused me to waste time or lose focus today?",
    reflections_1_50: "What did I learn today? How can I benefit from it?",
    reflections_1_60: "What and how should I do differently tomorrow?",
    reflections_2_10: "What am I grateful for?",
    reflections_2_20: "How did I spend my time today?",
    reflections_2_30: "Did I follow my plan? Was I productive?",
    reflections_2_40: "What were my time wasters today?",
    reflections_2_50: "How can I avoid them tomorrow?",
    reflections_3_10: "What did I accomplish today?",
    reflections_3_20: "Did I complete all my planned activities? Why?",
    reflections_3_30: "What inspired and energized me today?",
    reflections_3_40: "What should I focus on tomorrow?",
    reflections_3_50: "What should I do tomorrow to make it a better day?",
    reflections_4_10: "Am I making progress towards my goals? How can I do better?",
    reflections_4_20: "What's mostly missing from my life right now?",
    reflections_4_30: "What's driving me? What's truly important to me?",
    reflections_4_40: "What's stopping me?",
    reflections_4_50: "What can I do to overcome it?",
    reflections_4_60: "What's one thing I am committed to change or improve next week?",
    reflections_5_10: "What were my greatest accomplishments this past week?",
    reflections_5_20: "What were the biggest challenges I faced this week?",
    reflections_5_30: "What did I learn last week?",
    reflections_5_40: "What's most important for me to accomplish next week?",
    reflections_5_50: "What can I do to make next week less stressful and more joyful?",
    midday_10: "What's most important for me to accomplish today?",
    midday_20: "What's stopping me? What can I do to get over it?",
    midday_30: "What am I trying to avoid or delay but should do anyhow?",
    midday_40: "What is the main challenge I am currently facing?",
    midday_50: "What are possible solutions?",
  },

  trialPeriod: '7-Day Trial',
  plans: [
    {
      code: 'MONTHLY',
      cost: 14.95,
      description: '$14.95 USD per month',
      months: 1,
      title: '1 Month $14.95 USD',
    },
    {
      code: '6-MONTHS',
      cost: 59.95,
      description: '$59.95 USD for 6 months',
      months: 6,
      save: '33%',
      title: '6-Month $59.95 USD',
      tip: '7-Day Trial',
    },
    {
      code: 'YEARLY',
      cost: 99.95,
      description: '$99.95 USD for 1 year',
      months: 12,
      save: '44%',
      title: '1 year $99.95 USD',
      tip: '7-Day Trial',
    },
  ],

  archivedPlans: [
    {
      code: 'PRO-66110',
      cost: 15,
      description: '$15.00 USD a month',
      months: 1,
      tip: '10 days trial',
      title: '1 Month $15.00 USD',
    },
    {
      code: 'PRO-187853',
      cost: 30,
      description: '$30.00 USD for 3 months',
      months: 3,
      save: '33%',
      title: '3 Months $30.00 USD',
    },
    {
      code: 'PRO-66111',
      cost: 50,
      description: '$50.00 USD for 6 months',
      months: 6,
      save: '44%',
      title: '6 Months $50.00 USD',
    },
    {
      code: 'GIFT',
      cost: 0,
      months: 2,
      title: 'Gift',
    },
  ],

  videos: {
    clarity: {
      intro: 'https://evphosted-14ed4125c423d5.s3.amazonaws.com/starter-7205k-1-1.mp4',
    },
    identity: {
      // beliefs: 'https://www.youtube.com/embed/fmyQGqxUvVo',
      // dreams: 'https://www.youtube.com/embed/wjMnINA9phc',
      // habits2: 'https://www.youtube.com/embed/3MDza5vETjI',
      // habits: 'https://www.youtube.com/embed/7eexEmfg0OQ',
      intro: 'https://evphosted-14ed4125c423d5.s3.amazonaws.com/clarity-nov-720-5k-1-1.mp4',
      // passion2: 'https://www.youtube.com/embed/6kQkH9Ndqv8',
      // passion: 'https://www.youtube.com/embed/7OKGOxxZe18',
      // purpose2: 'https://www.youtube.com/embed/kj17W78c2VM',
      // purpose: 'https://www.youtube.com/embed/YOnlmVZ2JSY',
      // strengths2: 'https://www.youtube.com/embed/DeoufyV59uw',
      // strengths: 'https://www.youtube.com/embed/CH1iQAjRYnI',
      // values2: 'https://www.youtube.com/embed/sSvSGYemie8',
      // values: 'https://www.youtube.com/embed/IMqgbFYuclw',
      // vision: 'https://www.youtube.com/embed/wnzt2Kc0eKk',
    }
  }

}
